// components
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import SponsorshipText from '@/components/SponsorshipText/SponsorshipText';
import SponsorshipLogos from '@/components/SponsorshipLogos/SponsorshipLogos';

// styles
import styles from './SponsorshipFranchiseRow.module.scss';

export interface Sponsor {
  url: string;
  image: string;
  title: string;
}

interface SponsorshipFranchiseRowProps {
  id?: string;
  className?: string;
  title: string;
  source: {
    local_content_stations?: string[];
    funder_message?: string;
    sponsor_logos?: Sponsor[];
  };
  sponsorInfoLink?: string;
  sponsorshipLogosPagePosition: 'top' | 'bottom';
  // the absence of one of these props means that it should be visible at all breakpoints
  sponsorshipRowVisbility?: 'mobile' | 'desktop';
  sponsorshipTextVisibility?: 'mobile' | 'desktop';
}

const SponsorshipFranchiseRow: React.FC<SponsorshipFranchiseRowProps> = (props) => {
  const {
    className,
    id,
    source,
    sponsorInfoLink,
    sponsorshipLogosPagePosition,
    sponsorshipRowVisbility,
    sponsorshipTextVisibility,
    title,
  } = props;

  let responsiveClass = '';

  if (sponsorshipRowVisbility === 'mobile') {
    responsiveClass = ' visible_below_sm';
  } else if (sponsorshipRowVisbility === 'desktop') {
    responsiveClass = ' visible_above_sm';
  }

  const shouldRender =
    source.funder_message != '' ||
    (source.sponsor_logos && source.sponsor_logos?.length > 0) ||
    (source.local_content_stations && source.local_content_stations?.length > 0);

  if (shouldRender) {
    return (
      <div className={`${styles.sponsorship_franchise_row}${className ? ` ${className}` : ''}${responsiveClass}`} id={id}>
        <div>
          <SponsorshipText
            title={title}
            source={source}
            sponsorInfoLink={sponsorInfoLink}
            className={styles.sponsorship_franchise_row_text}
            sponsorshipTextVisibility={sponsorshipTextVisibility} />
        </div>
        <SponsorshipLogos
          sponsorshipLogos={source.sponsor_logos}
          sponsorshipLogosPagePosition={sponsorshipLogosPagePosition} />
      </div>
    );
  } else {
    return null;
  }
};

export default SponsorshipFranchiseRow;
